import gql from 'graphql-tag';

import { ExamShortFragment, MyExamScoreFragment } from './fragments/ExamFragment';

export const queryExams = gql`
  query Exams {
    exams {
      ...ExamShortFragment
    }
  }
  ${ExamShortFragment}
`;

export const queryMyExamScore = gql`
  query MyExamScores {
    myProfile {
      id
      myScores {
        ...MyExamScoreFragment
      }
    }
    exams(view: SCORE_FORM) {
      ...ExamShortFragment
      name
      fullScore
      subjectCode
    }
  }
  ${MyExamScoreFragment}
  ${ExamShortFragment}
`;
